<template>
  <div>
    <b-modal :id="`modal-${titleSlug}`" class="annexe-modal" :title="this.title" size="xl" hide-footer centered>
      <img :src="require(`@/assets/annexes/${this.picture}`)" :alt="this.title" class="img-fluid" v-if="this.type === 'picture'">
      <iframe :src="this.url" v-if="this.type === 'iframe'"></iframe>
      <iframe :src="`https://player.vimeo.com/video/${this.vimeoId}`" allow="autoplay; fullscreen" allowfullscreen v-if="this.type === 'video'"></iframe>
    </b-modal>
    <div class="annexe-card" :style="{'background-image': `url(${require(`@/assets/thumbnails/${this.thumbnail}`)})`}" v-b-modal="`modal-${titleSlug}`">
      <div class="annexe-duration" v-if="type === 'video'">
        <span class="duration-label">{{ time }}</span>
      </div>
      <div class="annexe-title">{{ this.title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnnexeCard',

  props: {
    title: String,
    thumbnail: {
      type: String,
      required: true
    },
    duration: Number,
    type: {
      validator: function (value) {
        return ['video', 'picture', 'iframe'].indexOf(value) !== -1
      },
      required: true
    },
    url: {
      type: String
    },
    picture: {
      type: String
    },
    vimeoId: {
      type: Number
    }
  },

  computed: {
    time: function () {
      console.log(this.duration)
      return `${~~(this.duration / 60)}:${(this.duration % 60 < 10 ? 0 : '')}${this.duration % 60}`
    },

    titleSlug: function () {
      const title = this.title

      return title.toLowerCase().split(' ').join('-')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .annexe-card {
    transition: box-shadow 0.3s ease-in-out;
    justify-content: space-between;
    background-position: center;
    background-size: cover;
    flex-direction: column;
    border-radius: .5rem;
    min-height: 170px;
    cursor: pointer;
    display: flex;

    &:hover {
      box-shadow: 0 0 30px 0 rgba(0, 0, 0, .5);
    }

    .annexe-duration {
      padding: .75rem;
      text-align: right;

      .duration-label {
        padding: .25rem .5rem;
        display: inline-block;
        border-radius: 2rem;
        font-size: .75rem;
        font-weight: 900;
        background: #000;
      }
    }

    .annexe-title {
      background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 1) 100%);
      padding: .75rem .75rem .5rem;
      text-transform: uppercase;
      border-radius: .5rem;
      text-align: right;
      font-size: .75rem;
      font-weight: 700;
      margin-top: auto;
    }
  }

  .modal {
    iframe {
      border-radius: .25rem;
      height: 600px;
      border: none;
      width: 100%;
    }
  }
</style>
